import type { SVGProps } from "react";

type P = SVGProps<SVGSVGElement>;

export type SocialKey = "instagram" | "tiktok" | "youtube" | "spotify" | "facebook" | "kwai";

const base = (props: P) => ({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": true,
  width: "1em",
  height: "1em",
  ...props,
});

export const Instagram = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 2.2c3.2 0 3.6 0 4.8.1 3.3.1 4.8 1.7 4.9 4.9.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 3.2-1.7 4.8-4.9 4.9-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-3.3-.1-4.8-1.7-4.9-4.9C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8C2.4 3.9 3.9 2.4 7.2 2.3 8.4 2.2 8.8 2.2 12 2.2zm0 3.4a6.4 6.4 0 1 0 0 12.8 6.4 6.4 0 0 0 0-12.8zm0 10.6a4.2 4.2 0 1 1 0-8.4 4.2 4.2 0 0 1 0 8.4zm6.6-12.3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
  </svg>
);

export const TikTok = (p: P) => (
  <svg {...base(p)}>
    <path d="M16.6 2h-3.4v13.4a2.9 2.9 0 1 1-2.9-2.9c.3 0 .6 0 .9.1V9.1a6.3 6.3 0 1 0 5.4 6.3V8.6a8 8 0 0 0 4.6 1.5V6.7A4.6 4.6 0 0 1 16.6 2z" />
  </svg>
);

export const YouTube = (p: P) => (
  <svg {...base(p)}>
    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z" />
  </svg>
);

export const Spotify = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm5.5 17.3a.7.7 0 0 1-1 .3c-2.8-1.7-6.4-2.1-10.6-1.2a.7.7 0 1 1-.3-1.4c4.6-1 8.5-.6 11.6 1.3.4.2.5.7.3 1zm1.5-3.3a.9.9 0 0 1-1.3.3c-3.2-2-8.2-2.6-12-1.4a.9.9 0 1 1-.5-1.8c4.4-1.3 9.8-.7 13.5 1.6.4.3.6.9.3 1.3zm.1-3.4C15.3 8.3 8.9 8.1 5.2 9.2a1.1 1.1 0 1 1-.6-2.1c4.3-1.3 11.3-1 15.7 1.6a1.1 1.1 0 0 1-1.2 1.9z" />
  </svg>
);

export const Facebook = (p: P) => (
  <svg {...base(p)}>
    <path d="M24 12a12 12 0 1 0-13.9 11.9v-8.4h-3V12h3V9.4c0-3 1.8-4.7 4.5-4.7 1.3 0 2.7.2 2.7.2v3h-1.5c-1.5 0-2 .9-2 1.9V12h3.4l-.5 3.5h-2.9v8.4A12 12 0 0 0 24 12z" />
  </svg>
);

export const WhatsApp = (p: P) => (
  <svg {...base(p)}>
    <path d="M17.5 14.4c-.3-.1-1.8-.9-2-1-.3-.1-.5-.1-.7.1l-.9 1.2c-.2.2-.3.2-.6.1-.3-.1-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6l.4-.5.3-.5v-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4zM12 21.8a9.8 9.8 0 0 1-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4A9.8 9.8 0 1 1 12 21.8zM12 0a12 12 0 0 0-10.3 18L0 24l6.2-1.6A12 12 0 1 0 12 0z" />
  </svg>
);

export const Play = (p: P) => (
  <svg {...base(p)}>
    <path d="M8 5.1v13.8a.6.6 0 0 0 .9.5l10.8-6.9a.6.6 0 0 0 0-1L8.9 4.6a.6.6 0 0 0-.9.5z" />
  </svg>
);

export const Arrow = (p: P) => (
  <svg {...base({ ...p, fill: "none", stroke: "currentColor", strokeWidth: 1.6 })}>
    <path d="M5 19 19 5M8 5h11v11" />
  </svg>
);

export const Kwai = (p: P) => (
  <svg {...base(p)}>
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-2.2 5.2 5.9 4.3a.6.6 0 0 1 0 1L9.8 16.8a.6.6 0 0 1-1-.5V7.7a.6.6 0 0 1 1-.5z" />
  </svg>
);

export const socialIcon: Record<SocialKey, (p: P) => React.JSX.Element> = {
  kwai: Kwai,
  instagram: Instagram,
  tiktok: TikTok,
  youtube: YouTube,
  spotify: Spotify,
  facebook: Facebook,
};

export const socialLabel: Record<SocialKey, string> = {
  kwai: "Kwai",
  instagram: "Instagram",
  tiktok: "TikTok",
  youtube: "YouTube",
  spotify: "Spotify",
  facebook: "Facebook",
};
